import { DomainObject } from 'types';

export const getNodeId = <T extends DomainObject & { baseIdentifier: string }>(
  node?: T
): string | undefined => node?.baseIdentifier ?? node?.id;
